import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => {
  // Radix gives every bar role="progressbar" + aria-valuenow but no accessible
  // NAME. Provide a percentage-based default so no bar is ever unnamed; callers
  // can still pass a more descriptive aria-label / aria-labelledby.
  const hasName = props["aria-label"] != null || props["aria-labelledby"] != null;
  return (
  <ProgressPrimitive.Root
    ref={ref}
    aria-label={hasName ? undefined : `Progress: ${Math.round(value || 0)}%`}
    className={cn(
      "relative h-4 w-full overflow-hidden rounded-full bg-secondary",
      className
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className="h-full w-full flex-1 bg-primary transition-all"
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </ProgressPrimitive.Root>
  );
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
